{
  "endTime": "Eindtijd",
  "startTime": "Starttijd",
  "time": "Tijd"
}
